import './app.css';



/* is production */
const isProd = process.env.NODE_ENV === 'production';



/* meta */
const meta = require('./js/meta.json');



/* analytics */
/* SEND EVENT: analyticsEvent('Button', 'click', {eventLabel: 'Play'}); */
const analytics = require('universal-ga');

analytics.initialize(meta.trackingID);
analytics.pageview('/index');

if (meta.clientTrackingID.length > 0) {
    analytics.create(meta.clientTrackingID, 'clientTracker');
    analytics.name('clientTracker').pageview('/index');
}

const analyticsEvent = (category, action, options) => {
    analytics.event(category, action, options);

    if (meta.clientTrackingID.length > 0) {
        analytics.name('clientTracker').event(category, action, options);
    }
};



/* fonts */
const WebFont = require('webfontloader');

WebFont.load({
    custom: {
        families: ['Tele2 TextSans:n4', 'Tele2 DisplaySerif:n7', 'Standard CT Stencil:n7'],
        urls: ['./css/fonts.css']
    }
});



/* service worker */
if ('serviceWorker' in navigator && isProd) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('./sw.js');
    });
}



/* states */
const setState = (newState) => {
    document.querySelector('body').setAttribute('data-state', newState);

    analyticsEvent('Page', 'load', {eventLabel: 'Page: ' + newState});
};



/* first action */
document.querySelector('.intro__action .button').addEventListener('click', () => {
    setState('questions');
});



/* share */
import * as VanillaSharing from 'vanilla-sharing';

const shareButtons = [...document.querySelectorAll('.share__item')];

const shareOptions = {
    url: meta.url,
    title: meta.title,
    description: meta.description,
    image: meta.image,
    isVkParse: false,
    fbAppId: meta.fbappid
};

if (navigator.share !== undefined) {
    document.querySelector('.share__item--all').classList.add('share__item--show');
}

if (shareButtons.length > 0) {

    shareButtons.forEach(button => {
        button.addEventListener('click', () => {
            if (button.dataset.social === 'all' && navigator.share !== undefined) {
                navigator.share({
                    title: shareOptions.title,
                    url: shareOptions.url
                });
            } else {
                VanillaSharing[button.dataset.social](shareOptions);
            }

            analyticsEvent('Share', 'click', {eventLabel: 'Social: ' + button.dataset.social});
        });
    });

}



/* tinder */
const Swing = require('swing');

let counter = 0;

const results = {
    v1: {
        min: 0,
        max: 3
    },
    v2: {
        min: 4,
        max: 8
    },
    v3: {
        min: 9,
        max: 11
    },
    v4: {
        min: 12,
        max: 15
    }
};

const items = [...document.querySelectorAll('.item')];

const swingConfig = {
    allowedDirections: [Swing.Direction.LEFT, Swing.Direction.RIGHT],
    throwOutConfidence: (xOffset, yOffset, element) => {
        const xConfidence = Math.min(Math.abs(xOffset) / (element.offsetWidth / 4), 1);
        const yConfidence = Math.min(Math.abs(yOffset) / (element.offsetHeight / 4), 1);
        return Math.max(xConfidence, yConfidence);
    }
};

const stack = Swing.Stack(swingConfig);

const cards = [];

items.forEach(item => {
    const card = stack.createCard(item);

    cards.push(card);
});

const clearAnswers = () => {
    document.querySelector('.answer--yes').removeAttribute('data-active');
    document.querySelector('.answer--no').removeAttribute('data-active');
};

cards.forEach(card => {

    card.on('dragmove', e => {
        e.target.style.opacity = 1 - e.throwOutConfidence;

        e.target.classList.add('item--move');

        if (e.throwDirection === Swing.Direction.LEFT) {
            clearAnswers();
            document.querySelector('.answer--yes').setAttribute('data-active', 'true');
        }

        if (e.throwDirection === Swing.Direction.RIGHT) {
            clearAnswers();
            document.querySelector('.answer--no').setAttribute('data-active', 'true');
        }
    });

    card.on('throwout', e => {
        if (e.throwDirection === Swing.Direction.LEFT) {
            counter = counter + 1;
            analyticsEvent('Answer', 'yes', {eventLabel: 'Question: ' + e.target.querySelector('.item__title').textContent});
        } else {
            analyticsEvent('Answer', 'no', {eventLabel: 'Question: ' + e.target.querySelector('.item__title').textContent});
        }

        e.target.classList.add('item--done');

        clearAnswers();
    });

    card.on('throwoutend', () => {
        card.destroy();
        cards.pop();

        clearAnswers();

        if (cards.length === 0) {
            if (counter >= results.v1.min && counter <= results.v1.max) {
                document.querySelector('body').setAttribute('data-result', '1');
                shareOptions.title = meta.results.v1.title;
                shareOptions.description = meta.results.v1.description;
                shareOptions.image = meta.results.v1.image;
                shareOptions.url = meta.results.v1.url;
            } else if (counter >= results.v2.min && counter <= results.v2.max) {
                document.querySelector('body').setAttribute('data-result', '2');
                shareOptions.title = meta.results.v2.title;
                shareOptions.description = meta.results.v2.description;
                shareOptions.image = meta.results.v2.image;
                shareOptions.url = meta.results.v2.url;
            } else if (counter >= results.v3.min && counter <= results.v3.max) {
                document.querySelector('body').setAttribute('data-result', '3');
                shareOptions.title = meta.results.v3.title;
                shareOptions.description = meta.results.v3.description;
                shareOptions.image = meta.results.v3.image;
                shareOptions.url = meta.results.v3.url;
            } else if (counter >= results.v4.min && counter <= results.v4.max) {
                document.querySelector('body').setAttribute('data-result', '4');
                shareOptions.title = meta.results.v4.title;
                shareOptions.description = meta.results.v4.description;
                shareOptions.image = meta.results.v4.image;
                shareOptions.url = meta.results.v4.url;
            }

            setState('results');
        }
    });

    card.on('throwin', e => {
        e.target.style.opacity = 1;

        e.target.classList.remove('item--move');

        clearAnswers();
    });

});



/* answers buttons */
document.querySelector('.answer--yes').addEventListener('click', () => {
    cards[cards.length - 1].throwOut(0, 0);
    counter = counter + 1;
});

document.querySelector('.answer--no').addEventListener('click', () => {
    cards[cards.length - 1].throwOut(0, 0);
});



/* more */
document.querySelector('.result-more').addEventListener('click', () => {
    analyticsEvent('Button', 'click', {eventLabel: 'More'});
});



/* clicks */
document.querySelector('.header__tele2').addEventListener('click', () => {
    analyticsEvent('Link', 'click', {eventLabel: 'Tele2 Logo'});
});

document.querySelector('.header__afisha').addEventListener('click', () => {
    analyticsEvent('Link', 'click', {eventLabel: 'Afisha Logo'});
});


// WEBPACK FOOTER //
// ./app.js